import { atom, useSetRecoilState } from 'recoil';
import { v4 as uuidv4 } from 'uuid';

export interface ApiDispatchItem {
  requestId: string;
  method: 'get' | 'post' | 'put' | 'patch' | 'delete';
  route: string;
  body?: any;
  header: any;
  onSuccess?: (res: any) => void;
  onFailure?: (error: any) => void;
}

export interface ApiDispatchConfig {
  queue: ApiDispatchItem[];
  loading: boolean;
}

export const ApiDispatchState = atom<ApiDispatchConfig>({
  key: 'ApiDispatchState',
  default: {
    queue: [],
    loading: false,
  },
});

export const useApiDispatchQueue = () => {
  const setApiDispatchState = useSetRecoilState(ApiDispatchState);

  return (item: Omit<ApiDispatchItem, 'requestId'>) => {
    const requestId = `request_${uuidv4()}`;
    setApiDispatchState((state) => ({
      ...state,
      queue: [...state.queue, { ...item, requestId }],
    }));
  }
}
